/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateFreeeSelectCompany200Response
 */
export interface UpdateFreeeSelectCompany200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'freeeCompanyId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'freeeCompanyName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'cardAccountUnit': UpdateFreeeSelectCompany200ResponseCardAccountUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'connectedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'isJournalFeatureEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'journalEntryTransitionModeEndDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'accountItemIdForPointUse': string;
}

export const UpdateFreeeSelectCompany200ResponseCardAccountUnitEnum = {
    all: 'ALL',
    group: 'GROUP',
    single: 'SINGLE'
} as const;

export type UpdateFreeeSelectCompany200ResponseCardAccountUnitEnum = typeof UpdateFreeeSelectCompany200ResponseCardAccountUnitEnum[keyof typeof UpdateFreeeSelectCompany200ResponseCardAccountUnitEnum];


